<template>
  <!------------Research Section start----------->
  <div id="research" class="page">
    <div class="pageheader">

      <div class="headercontent">

        <div class="section-container">
          <!--------Title section-------->
          <h2 class="title">Summary</h2>

          <div class="row">
            <div class="col-md-8">
              <p class="text-left">I’m an enthusiast researcher working to better
                understand how modern artificial intelligence technologies can be used for better human life. My expertise includes deep learning, computer vision, and the development. My primary focus is to develop scalable and robust deep learning based solutions for real-life problems.</p>
            </div>

            <!--------Interests section Start-------->
            <div class="col-md-4">
              <div class="subtitle text-center">
                <h3>Interests</h3>
              </div>
              <ul class="ul-boxed list-unstyled">
                <li>Deep Learning</li>
                <li>Computer Vision</li>
                <li>Machine Learning</li>
                <li>Pattern Reorganization</li>
                <li>Natural Language Processing</li>
                <li>Development(Laravel,VueJs, NuxtJS)</li>
              </ul>
            </div>
            <!--------Interests section End-------->
          </div>
          <!--------Descrition section end-------->
        </div>
        <!--------Research sumary section end-------->
      </div>
    </div>

    <div class="pagecontents">

      <!--------Laboratory Personel section start-------->
<!--      <div class="section color-1">
        <div class="section-container">
          <div class="title text-center">

            &lt;!&ndash;&#45;&#45;&#45;&#45;&#45;&#45;Title section&#45;&#45;&#45;&#45;&#45;&#45;&ndash;&gt;
            <h3>Laboratory Personnel</h3>
          </div>
          <div class="row">
            <div class="col-md-10">

              <div id="labp-heads-wrap">

                <div id="lab-carousel">

                  <div><img alt="image" :src="'/img/06.jpg'" width="120" height="120" class="img-circle lab-img" /></div>
                  <div><img alt="image" :src="'/img/06.jpg'" width="120" height="120" class="img-circle lab-img" /></div>

                </div>
                <div>
                  <a href="#" id="prev"><i class="icon-chevron-sign-left"></i></a>
                  <a href="#" id="next"><i class="icon-chevron-sign-right"></i></a>
                </div>
              </div>

              <div id="lab-details">
                <div>
                  <h3>Md Abdul Karim</h3>
                  <h4>Facebook fellow</h4>
                  <a href="https://www.facebook.com/ab.karim007" target="_blank" class="btn btn-info">+ Follow</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>-->
      <!--------Laboratory Personel section end-------->

      <!--------Research project section Start-------->
      <div class="section color-2">
        <div class="section-container">
          <div class="title text-center">
            <h3>Projects</h3>
          </div>
          <div class="row">
            <div class="col-md-12">
              <ul class="ul-withdetails">
                <li>
                  <div class="row">
                    <div class="col-sm-6 col-md-3">
                      <div class="image">
                        <img alt="image" :src="'/img/projects/school.jpg'" height="300px"  class="img-responsive">
                        <div class="imageoverlay">
                          <i class="icon icon-search"></i>
                        </div>

                      </div>
                    </div>
                    <div class="col-sm-6 col-md-9">
                      <div class="meta">
                        <h3>School Management System</h3>
                        <p></p>
                      </div>
                    </div>
                  </div>
                  <div class="details">
<!--                    <h4>Aim</h4>
                    <p>The ultimate goal of this research is to collaboratively build semantic content platform that combines augmented reality and the semantic Web.
                    </p>
                    <h4>Skills Developed</h4>-->
                    <p class="text-left">
                      This school management system is built on a highly secure and most popular Laravel Framework which is built on MVC Design Pattern Laravel with VueJs. This system has three main Feature <br>

                      i) "API" this is height secure api manage app which is build on laravel framwork and Passport token auth 2.0. <br>
                      ii)"School app" using this app school admin, teacher, student, parent, account admin can do their work. <br>
                      ii) "Public site" This is the site for an institute pubic site. <br>
                      other feature
                      &#8649; New role creates and permission set a, <br>
                      &#8649; school class, branch, version, student group, academic year manage <br>
                      &#8649; student add, edit, update, promotions, transfer certificate <br>
                      &#8649; teacher add,edit,updated,manage <br>
                      &#8649; student result grade and mark distribution manage and auto result calculation <br>
                      &#8649; teacher grade, scale, designation, salary, loan, provident fund manage <br>
                      &#8649; student subject add,update(4th subject,option subject,grade subject,etc maintain automatically) <br>
                      &#8649; student fee assign, late fee assign, waiver maintain <br>
                      &#8649; student and teacher leave request maintain, <br>
                      &#8649; Expense manage <br>
                      &#8649; different type of report <br>
                      &#8649; also has API for android/ios
                    </p>
                  </div>
                </li>
                <li>
                  <div class="row">
                    <div class="col-sm-6 col-md-3">
                      <div class="image">
                        <img alt="image" :src="'/img/projects/shop.png'"  class="img-responsive">
                        <div class="imageoverlay">
                          <i class="icon icon-search"></i>
                        </div>

                      </div>
                    </div>
                    <div class="col-sm-6 col-md-9">
                      <div class="meta">
                        <h3>Online Shop</h3>
                        <p></p>
                      </div>
                    </div>
                  </div>
                  <div class="details">
<!--                    <h4>Aim</h4>
                    <p>The ultimate goal of this research is to collaboratively build semantic content platform that combines augmented reality and the semantic Web.
                    </p>
                    <h4>Skills Developed</h4>-->
                    <p class="text-left">
                      Online Shop
                      Management system is build on MVC model. The system has Two type of Authenticate user Admin and Customer.
                      The system provides functionalities like a Inventory system, order management and in depth business analytics.
                      Powered by technologies like Laravel, Vue.js, Node.js, SSL Commerce payment get way.
                      also manage products and make delivery and manage transactions. Can manage products offer, Promo code, Subscriber notification etc.
                      Customers can buy anything and manage their shipping information and basic other information.
                      The customer can track his order information.
                    </p>
                  </div>
                </li>
                <li>
                  <div class="row">
                    <div class="col-sm-6 col-md-3">
                      <div class="image">
                        <img alt="image" :src="'/img/projects/shop.png'"  class="img-responsive">
                        <div class="imageoverlay">
                          <i class="icon icon-search"></i>
                        </div>

                      </div>
                    </div>
                    <div class="col-sm-6 col-md-9">
                      <div class="meta">
                        <h3>AbeerFood</h3>
                        <p></p>
                      </div>
                    </div>
                  </div>
                  <div class="details">
<!--                    <h4>Aim</h4>
                    <p>The ultimate goal of this research is to collaboratively build semantic content platform that combines augmented reality and the semantic Web.
                    </p>
                    <h4>Skills Developed</h4>-->
                    <p class="text-left">
                      Abeer Food is a
                      dedicated restaurant management system that follows MVC model. The system has Four type of Authenticate user
                      Admin(who is control all type of user and all functionality), Author(This type of use is a restaurant owner create
                      product and manage orders), Rider(who deliver the orders) and Customer. The system provides functionalities like
                      a Inventory system, order management and in depth business analytics. Powered by technologies like Laravel,
                      Vue.js, Node.js, Paypal and Stripe payment getway, Google map API.
                    </p>
                  </div>
                </li>
                <li>
                  <div class="row">
                    <div class="col-sm-6 col-md-3">
                      <div class="image">
                        <img alt="image" :src="'/img/projects/inventory.png'"  class="img-responsive">
                        <div class="imageoverlay">
                          <i class="icon icon-search"></i>
                        </div>

                      </div>
                    </div>
                    <div class="col-sm-6 col-md-9">
                      <div class="meta">
                        <h3>Inventory Management</h3>
                        <p></p>
                      </div>
                    </div>
                  </div>
                  <div class="details">
<!--                    <h4>Aim</h4>
                    <p>The ultimate goal of this research is to collaboratively build semantic content platform that combines augmented reality and the semantic Web.
                    </p>
                    <h4>Skills Developed</h4>-->
                    <p class="text-left">
                      Shop inventory system is built on most popular framework laravel and MVC model This inventory system has many types of work and different type of report fetchers, such as:
                      &#8649; Easy to maintain and faster operation.<br>
                      &#8649; Dashboard total sale, today sale, total expense, today expense, total revenue, today revenue, total due, today due, total customer, total product, out of the stock product, etc show. <br>
                      &#8649; The company adds, updates, removes, this company's total products show. <br>
                      &#8649; Category adds, update this category total products. <br>
                      &#8649; Different types of users and their permission access control. <br>
                      &#8649; Easily stock in stock out. <br>
                      &#8649; Customer information store. <br>
                      &#8649; Customer wise all transaction report view date-wise transaction report. <br>
                      &#8649; All Stock in the report, date range wise stock in a report <br>
                      &#8649; Stockout report all and date wise and date range wise <br>
                      &#8649; Expense report date wise and date range wise <br>
                      &#8649; Expense type add <br>
                      &#8649; Expense type-wise report <br>
                      &#8649; Every report can be exported as Excel, CSV, pdf and others
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!--------Research project section end-------->
    </div>
  </div>
  <!------------Research Section end----------->
</template>
<script>
export default {
  name: 'Research',
}
</script>